import React from 'react';
import { motion } from 'framer-motion';
import { needs } from '../../data/needs';
import { brand } from '../../data/palette';
import type { NeedId } from '../../types/filtek';
interface NeedsRibbonProps {
  selected?: NeedId;
  explored: string[];
  matched?: NeedId;
  onSelect: (id: NeedId) => void;
}

/** A horizontal journey across the clinical demands of a working week. */
export function NeedsRibbon({
  selected,
  explored,
  matched,
  onSelect
}: NeedsRibbonProps) {
  return <div className="no-scrollbar -mx-6 overflow-x-auto px-6 sm:mx-0 sm:px-0" data-id="element-98" data-mp="3lni35qf01r4m">
      <div className="relative h-44 min-w-[44rem] sm:min-w-0" data-id="element-99" data-mp="3llffhd1bka32">
        <span className="absolute inset-x-0 bottom-[12px] h-px bg-enamel/10" aria-hidden="true" data-id="element-100" data-mp="36pfzlg7yx5nd" />

        <div className="relative flex h-full" data-id="element-101" data-mp="3bo10ziyyhvde">
          {needs.map(need => {
          const isSelected = selected === need.id;
          const isExplored = explored.includes(need.id);
          return <button key={need.id} type="button" onClick={() => onSelect(need.id)} aria-pressed={isSelected} className="group relative flex h-full flex-1 flex-col items-center justify-end gap-4 px-2" data-id="element-102" data-mp="20bqfzyqgf3ji">
                {matched === need.id && !isSelected && <span className="label-mono absolute top-0 text-[8px] text-mute/70" data-id="element-103" data-mp="2wakcnqqqmg4b">
                    Matches you
                  </span>}

                <span className="text-center text-base font-light leading-tight tracking-[-0.02em] transition-all duration-500 group-hover:-translate-y-1 sm:text-lg lg:text-xl" style={{
              color: isSelected ? need.accent : isExplored ? 'var(--enamel)' : brand.dim
            }} data-id="element-104" data-mp="3b68gvfw23387">
                  {need.label}
                </span>

                <span className="label-mono text-[9px] text-mute/50" data-id="element-105" data-mp="3ozrb6pq6z5pk">{need.index}</span>

                <span className="relative mb-[2px] flex h-5 w-5 items-center justify-center" data-id="element-106" data-mp="3oxwop6z9v5jd">
                  <motion.span className="absolute rounded-full" style={{
                backgroundColor: need.accent
              }} initial={false} animate={{
                width: isSelected ? 11 : 7,
                height: isSelected ? 11 : 7,
                opacity: isSelected ? 1 : isExplored ? 0.75 : 0.28
              }} transition={{
                duration: 0.45,
                ease: [0.16, 1, 0.3, 1]
              }} data-id="element-107" data-mp="2mk8muye3ow2a" />
                  {isSelected && <motion.span className="absolute h-3 w-3 rounded-full" style={{
                border: `1px solid ${need.accent}`
              }} animate={{
                scale: [1, 2.4],
                opacity: [0.7, 0]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeOut'
              }} data-id="element-108" data-mp="3ed9bf34ax40e" />}
                </span>
              </button>;
        })}
        </div>
      </div>
    </div>;
}